// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CheckConcurrentTenancyRequestDTO } from '../models';
import { ConcurrentTenancyCheckResultDTO } from '../models';
/**
 * ConcurrentTenancyCheckApi - axios parameter creator
 * @export
 */
export const ConcurrentTenancyCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if concurrent tenancy blocking would occur for given tenant emails and start date
         * @param {CheckConcurrentTenancyRequestDTO} checkConcurrentTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConcurrentTenancy(checkConcurrentTenancyRequestDTO: CheckConcurrentTenancyRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'checkConcurrentTenancyRequestDTO' is not null or undefined
            if (checkConcurrentTenancyRequestDTO === null || checkConcurrentTenancyRequestDTO === undefined) {
                throw new RequiredError('checkConcurrentTenancyRequestDTO','Required parameter checkConcurrentTenancyRequestDTO was null or undefined when calling checkConcurrentTenancy.');
            }
            const localVarPath = `/v2/concurrent-tenancy-check`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CheckConcurrentTenancyRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(checkConcurrentTenancyRequestDTO !== undefined ? checkConcurrentTenancyRequestDTO : {}) : (checkConcurrentTenancyRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConcurrentTenancyCheckApi - functional programming interface
 * @export
 */
export const ConcurrentTenancyCheckApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Check if concurrent tenancy blocking would occur for given tenant emails and start date
         * @param {CheckConcurrentTenancyRequestDTO} checkConcurrentTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConcurrentTenancy(checkConcurrentTenancyRequestDTO: CheckConcurrentTenancyRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConcurrentTenancyCheckResultDTO> {
            const localVarAxiosArgs = ConcurrentTenancyCheckApiAxiosParamCreator(configuration).checkConcurrentTenancy(checkConcurrentTenancyRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConcurrentTenancyCheckApi - factory interface
 * @export
 */
export const ConcurrentTenancyCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Check if concurrent tenancy blocking would occur for given tenant emails and start date
         * @param {CheckConcurrentTenancyRequestDTO} checkConcurrentTenancyRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConcurrentTenancy(checkConcurrentTenancyRequestDTO: CheckConcurrentTenancyRequestDTO, options?: any) {
            return ConcurrentTenancyCheckApiFp(configuration).checkConcurrentTenancy(checkConcurrentTenancyRequestDTO, options)(axios, basePath);
        },
    };
};

/**
 * ConcurrentTenancyCheckApi - interface
 * @export
 * @interface ConcurrentTenancyCheckApi
 */
export interface ConcurrentTenancyCheckApiInterface {
    /**
     * Check if concurrent tenancy blocking would occur for given tenant emails and start date
     * @param {CheckConcurrentTenancyRequestDTO} checkConcurrentTenancyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConcurrentTenancyCheckApiInterface
     */
    checkConcurrentTenancy(checkConcurrentTenancyRequestDTO: CheckConcurrentTenancyRequestDTO, options?: any): AxiosPromise<ConcurrentTenancyCheckResultDTO>;

}

/**
 * ConcurrentTenancyCheckApi - object-oriented interface
 * @export
 * @class ConcurrentTenancyCheckApi
 * @extends {BaseAPI}
 */
export class ConcurrentTenancyCheckApi extends BaseAPI implements ConcurrentTenancyCheckApiInterface {
    /**
     * Check if concurrent tenancy blocking would occur for given tenant emails and start date
     * @param {CheckConcurrentTenancyRequestDTO} checkConcurrentTenancyRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConcurrentTenancyCheckApi
     */
    public checkConcurrentTenancy(checkConcurrentTenancyRequestDTO: CheckConcurrentTenancyRequestDTO, options?: any) {
        return ConcurrentTenancyCheckApiFp(this.configuration).checkConcurrentTenancy(checkConcurrentTenancyRequestDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ConcurrentTenancyCheckApi
 * Import individual functions for optimal bundle size
 */
/**
 * Check if concurrent tenancy blocking would occur for given tenant emails and start date
 * @param {CheckConcurrentTenancyRequestDTO} checkConcurrentTenancyRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function checkConcurrentTenancy(
    checkConcurrentTenancyRequestDTO: CheckConcurrentTenancyRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ConcurrentTenancyCheckResultDTO> {
    const localVarAxiosArgs = ConcurrentTenancyCheckApiAxiosParamCreator(configuration).checkConcurrentTenancy(checkConcurrentTenancyRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

